import { MutationTree } from 'vuex';
import { GenericFormState } from './types';
import IFromFlow from '@/modules/form/interfaces/IFormFlow.d.ts';
import IFormState from '@/modules/form/interfaces/IFormState.d.ts';
import IFormField from '@/modules/form/interfaces/IFormField.d.ts';

export const mutations: MutationTree<GenericFormState> = {
    setCurrentStepIdx(state, currentStepIdx: number) {
        state.currentStepIdx = currentStepIdx;
    },
    setStepsNumber(state, stepsNumber: number) {
        state.stepsNumber = stepsNumber;
    },
    setEventId(state, eventId: number) {
        state.eventId = eventId;
    },
    setEventTypeId(state, eventTypeId: number) {
        state.eventTypeId = eventTypeId;
    },
    setFormStateId(state, formStateId: number) {
        state.formStateId = formStateId;
    },
    setFormFlowId(state, formFlowId: number) {
        state.formFlowId = formFlowId;
    },
    setFormStateName(state, formStateName: string) {
        state.formStateName = formStateName;
    },
    setFormFields(state, formFields: IFormField[]) {
        state.formFields = formFields;
    },
    setFormStates(state, formStates: IFormState[]) {
        state.formStates = formStates;
    },
    setCurrentFormState(state, currentFormState: IFormState) {
        state.currentFormState = currentFormState;
    },
    setFormFlows(state, formFlows: IFromFlow[]) {
        state.formFlows = formFlows;
    },
};
